export default __webpack_public_path__ + "static/media/dashbaord_suspend-Grey.a7efb582.svg";